
    var riot = require('riot')
    //src: starling/src/tags/map-alert.html
riot.tag2('map-alert',
  '<span class="MapAlert__Icon" if="{icon}"> <i class="material-icons">{icon}</i> </span> <span>{content}</span> <a if="{link}" class="MapAlert__Button" href="{link.url}"> {link.label} </a> <button if="{closable}" class="MapAlert__Close" onclick="{hide}"> <i class="material-icons">close</i> </button>',
  '',
  'class="MapAlert MapAlert--{type} {isVisible && content ? \'\' : \'MapAlert--Hidden\'} animated" role="alert"', function(opts) {
'use strict';

var _this = this;

this.isVisible = false;

this.set = function (_ref) {
  var content = _ref.content,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'Info' : _ref$type,
      icon = _ref.icon,
      link = _ref.link,
      closable = _ref.closable,
      isVisible = _ref.isVisible;

  Object.assign(_this, { content: content, type: type, icon: icon, link: link, closable: closable, isVisible: isVisible });
  _this.update();
};

this.show = function (_ref2) {
  var content = _ref2.content,
      type = _ref2.type,
      icon = _ref2.icon,
      link = _ref2.link,
      closable = _ref2.closable;

  _this.set({ content: content, type: type, icon: icon, link: link, closable: closable, isVisible: true });
  _this.root.classList.add('fadeInDown', 'faster');
};

this.hide = function () {
  _this.root.classList.add('fadeOutUp', 'faster');

  setTimeout(function () {
    _this.set({ isVisible: false });
  }, 500);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('map-alert')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/map-alert.html
// module id = 645
// module chunks = 0